// extracted by mini-css-extract-plugin
export var colorSquare = "_md-0";
export var danger = "_md-5";
export var lightPink = "_md-8";
export var neutralBlue = "_md-7";
export var neutralYellow = "_md-6";
export var normal = "_md-1";
export var primary = "_md-2";
export var primaryLight = "_md-3";
export var solidBlack = "_md-g";
export var solidGreen = "_md-b";
export var solidLightBlue = "_md-d";
export var solidNavy = "_md-c";
export var solidOrange = "_md-f";
export var solidPink = "_md-e";
export var solidRed = "_md-9";
export var solidYellow = "_md-a";
export var success = "_md-4";